import { query } from '@confluence/query-preloader-tools';

import { StarredContentMenuQuery } from './queries/StarredContentMenuQuery.graphql';

export function preloadStarredContentMenu() {
	return query({ query: StarredContentMenuQuery, fetchPolicy: 'network-only' });
}
